import type { MentionUser } from 'types/discussion'

/** The first 8 users whose label, display name or description contains `query`. */
export function filterUsers(
  users: MentionUser[],
  query: string,
): MentionUser[] {
  const q = query.toLowerCase()
  return users
    .filter(user =>
      [user.label, user.display, user.description].some(field =>
        field?.toLowerCase().includes(q),
      ),
    )
    .slice(0, 8)
}
